export default __webpack_public_path__ + "static/media/about.192efbf9.png";